// extracted by mini-css-extract-plugin
export default {"topBox":"topBox--BOUER","topBox-nav":"topBox-nav--fleyu","active":"active--vh89h","new-tag":"new-tag--OcnfU"};